import firebase from 'firebase/app'
import 'firebase/database'
import 'firebase/auth'

let config = {
  apiKey: process.env.FIREBASE_API_KEY,
  authDomain: process.env.FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.FIREBASE_DATABASE_URL,
  projectId: process.env.FIREBASE_PROJECT_ID,
  storageBucket: process.env.FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.FIREBASE_MESSENGER_SENDER_ID
}

var app = firebase.initializeApp(config)

firebase.auth().signInWithEmailAndPassword(process.env.FIREBASE_SERVICE_WORKER_EMAIL, process.env.FIREBASE_SERVICE_WORKER_PASSWORD).catch(function (error) {
  console.error(error)
})

export let client = app



// WEBPACK FOOTER //
// ./src/api/webcontent/client.js